import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/counter';
import Home from './pages/Home';
import Domains from './pages/Domains';
import Hosting from './pages/Hosting';
import Footer from './components/Footer';
import Checkout from './pages/Checkout';
import FAQ from "./pages/FAQ"; 
import About from "./pages/About"; 
import Contact from "./pages/contact"; 
import ScrollToTop from "./components/scrolltotop";
import OtherServices from "./pages/OtherServices";
import AdminLogin from "./pages/Admin";
import AdminDashboard from "./pages/AdminDashboard";
import WhatsAppButton from './components/whatsapp';
import NotFound from "./pages/NotFound";


import { CartProvider } from './shared/CartContext';

function App() {
  const location = useLocation();

  // Check if the current route starts with "/admin"
  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <CartProvider>
      <div className="min-h-screen flex flex-col bg-gradient-to-b from-white to-blue-50">
        
        {!isAdminPage && <Header />}
        
        <ScrollToTop /> 
        
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/domains" element={<Domains />} />
            <Route path="/hosting" element={<Hosting />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/About" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/other-services" element={<OtherServices />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          {!isAdminPage && <WhatsAppButton/>}
        </main>

        {!isAdminPage && <Footer />}
      </div>
    </CartProvider>
  );
}

export default App;
